export const ENTITY_PREFIX = 'entities';
export const REMOTE_PREFIX = 'remote';
